import React from 'react';
import { Button } from '../../components/Button';
import { Modal } from '../../components/Modal';

import { MONEY_BACK_GUARANTEE_DAYS } from '@bidetny/config';

interface GuaranteeModalProps {
  open: boolean;
  onClose: () => void;
}

export const GuaranteeModal: React.FC<GuaranteeModalProps> = ({ open, onClose }) => (
  <Modal
    open={open}
    onClose={onClose}
    containerClassName="max-w-md p-4"
  >
    <div className="w-full text-black relative text-left">
      <h3 className="text-xl font-bold mb-4">Our Guarantee</h3>
      <p className="mb-6 text-base">
        If your bottom isn't appreciating the complete and fresh clean uniquely delivered by your bidet, email
        {' '}
        <a href="mailto:support@bidetny.com" className="underline text-blue-600">support@bidetny.com</a>
        {' '}
        within {MONEY_BACK_GUARANTEE_DAYS} days of installation. We'll share tips to help you improve your experience, and if you're still not a fan, we'll refund the cost of your order.
      </p>
      <p className="mb-6 text-">
        Please note that guaranteed returns do require uninstallation and are subject to a possible return handling fee, depending on the make and model.
      </p>
      <Button
        type="button"
        cta
        onClick={onClose}
        className="py-2 px-6 rounded-full shadow border-2 border-yellow-500 focus:outline-none focus:ring-2 focus:ring-yellow-500"
      >
        Got it
      </Button>
    </div>
  </Modal>
);
